export const FRAME_PROCESSOR_INPUT_MESSAGES = ({
  CANCEL: 'cancel',
  EXTRACT_FRAMES: 'extract_frames',
  DECODE_FRAME: 'decode_frame'
} as const);
export const FRAME_PROCESSOR_OUTPUT_MESSAGES = ({
  PROGRESS: 'progress',
  ERROR: 'error',
  FRAME_DETAILS: 'frame_details',
  FRAMES_CACHED: 'frames_cached',
  DECODED_FRAME: 'decoded_frame'
} as const);
export const FRAME_DETAILS_STATUS = ({
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
} as const);
export const FRAME_PROCESSOR_ERROR_CODES = ({
  // Demuxer errors (frame extraction failures)
  NO_VIDEO_TRACK: 'NO_VIDEO_TRACK',
  INCOMPLETE_VIDEO_DOWNLOAD: 'INCOMPLETE_VIDEO_DOWNLOAD',
  VIDEO_FETCH_ERROR: 'VIDEO_FETCH_ERROR',
  VIDEO_STREAM_ERROR: 'VIDEO_STREAM_ERROR',
  VIDEO_STREAM_READ_ERROR: 'VIDEO_STREAM_READ_ERROR',
  VIDEO_PARSE_ERROR: 'VIDEO_PARSE_ERROR',
  DEMUX_ABORTED: 'DEMUX_ABORTED',
  // Decoder errors (frame decoding failures)
  VIDEO_NOT_READY: 'VIDEO_NOT_READY',
  FRAME_NOT_IN_CACHE: 'FRAME_NOT_IN_CACHE',
  FRAME_DATA_ERROR: 'FRAME_DATA_ERROR',
  DECODER_ERROR: 'DECODER_ERROR',
  DECODER_CONFIGURATION_ERROR: 'DECODER_CONFIGURATION_ERROR',
  KEYFRAME_NOT_FOUND: 'KEYFRAME_NOT_FOUND',
  VIDEO_CHUNK_CREATION_ERROR: 'VIDEO_CHUNK_CREATION_ERROR',
  DECODE_CHUNKS_ERROR: 'DECODE_CHUNKS_ERROR',
  FLUSH_ERROR: 'FLUSH_ERROR'
} as const);